import { Link } from 'react-router-dom';

export default function Footer({ logged }: { logged: boolean }) {
  return (
    <footer className="border-t border-border py-10">
      <div className="max-w-[1040px] mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-2.5">
          <span className="w-6 h-6 rounded-md bg-accentSoft border border-accentLine flex items-center justify-center">
            <i className="ri-stack-line text-accent text-sm" />
          </span>
          <span className="text-sm text-texts">Sourcetape · sourcetape.io</span>
        </div>
        <nav className="flex items-center gap-6 flex-wrap justify-center">
          <a href="/#gallery" className="text-sm text-texts hover:text-textp transition-colors whitespace-nowrap">Gallery</a>
          <Link to="/studio" className="text-sm text-texts hover:text-textp transition-colors whitespace-nowrap">Studio</Link>
          <Link to={logged ? '/dashboard' : '/login'} className="text-sm text-texts hover:text-textp transition-colors whitespace-nowrap">
            {logged ? 'Dashboard' : 'Sign in'}
          </Link>
          <a href="/#faq" className="text-sm text-texts hover:text-textp transition-colors whitespace-nowrap">FAQ</a>
          <Link to="/privacy" className="text-sm text-texts hover:text-textp transition-colors whitespace-nowrap">Privacy</Link>
          <Link to="/terms-of-use" className="text-sm text-texts hover:text-textp transition-colors whitespace-nowrap">Terms of Use</Link>
        </nav>
      </div>
    </footer>
  );
}
